export const en = {
  jetStyleLink: 'https://jet.style',
  logo: 'Unit Economics Calculator',
  acquiredUsers: 'Acquired users',
  costOfSoldGood: 'Cost per unit of goods sold',
  revenuePerUser: 'Revenue per paying user',
  profitMessage: 'You scale profits',
  lossMessage: 'You scale the loss',
  descUA: 'User Acquisition is an indicator that indicates the number of users attracted from this ad channel.',
  descCPC: 'Cost per acquisition of one User. It is determined by dividing the entire marketing budget by the number of all Users. Unlike CAC, CPA is an actionable metric. It doesn’t depend on other metrics, such as conversion or User flow.',
  descCR1: 'Conversion on the first step of the funnel (usually in the application) - the percentage of visitors to the site (service) who committed the targeted action to contact (registered, sent an application, called).',
  descCR2: 'Conversion on the second step of the funnel (usually from the application for sale) is the percentage of the users who left the application who ultimately made the transaction (made a purchase, paid a subscription, etc.).',
  descAvP: 'The sum of money our customer paid for our goods or services.',
  descCOGS: 'Average costs that the enterprise incurs to secure sales (cost of goods, packaging and shipping costs, etc.).',
  descrRet: 'Average number of payments made by one customer during a set period of time. APC by default is counted for the whole life period. This value should be calculated carefully. It should never be rounded up.',
  allMetrics: 'All metrics',
  feedbackFormTitle: 'Got questions? Have a different business model to calculate? <br /> Need help? Contact us!',
  currencySymbol: '€',
  currencyText: '€',
  feedbackFormName: 'Name',
  feedbackFormEmail: 'Your e-mail',
  feedbackFormPhone: 'Phone number',
  feedbackFormQuestion: 'Leave your questions or comments here',
  feedbackFormSend: 'Contact us!',
  allRights: 'All rights reserved.',
  privacyPoliticText: 'By clicking on the "Contact us!" button, I agree to the processing of my personal data according to the',
  privacyPoliticLinkText: 'Privacy Policy',
  privacyPoliticHref: 'https://jet.style/privacy',
  validateRequire: 'Required field',
  validateEmail: 'Not a valid email address'
};



// WEBPACK FOOTER //
// ./src/services/language_en.js